import { NextRouter } from 'next/router';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { getSupplierUrl } from '@bridebook/toolbox/src';

export enum GallerySection {
  Photos = 'photos',
  Videos = 'videos',
  VideoTours = 'videotours',
}

export const openGallery = (router: NextRouter, supplier: ISupplier, section?: GallerySection) => {
  const supplierGalleryUrl = `${getSupplierUrl(supplier)}/gallery${section ? `#${section}` : ''}`;
  // FIXME: this should use shallow routing, however it seems that we have a problem with
  //  previousPath in that case, which breaks other things like piling counter and back button
  router.push(supplierGalleryUrl);
};

export const closeGallery = (router: NextRouter, supplier: ISupplier, hasPreviousPath: boolean) => {
  if (hasPreviousPath) {
    router.back();
  } else {
    // If gallery was opened directly from URL, then on close redirect to supplier profile
    const supplierUrl = getSupplierUrl(supplier);
    // FIXME: this should use shallow routing, however it seems that we have a problem with
    //  previousPath in that case, which breaks other things like piling counter and back button
    router.push(supplierUrl);
  }
};
